import React, { StrictMode } from 'react';
import { BrowserRouter, MemoryRouter } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageProvider';
import { WordPressProvider } from './context';
import App from 'components/App';
import { getCachedUrl, isWebcache } from 'utils/routes';

const Root = () => {
  return (
    <StrictMode>
      <WordPressProvider
        config={{
          url: process.env.REACT_APP_WP_API || '',
        }}
      >
        {isWebcache() ? (
          <MemoryRouter initialEntries={[getCachedUrl()]}>
            <LanguageProvider>
              <App />
            </LanguageProvider>
          </MemoryRouter>
        ) : (
          <BrowserRouter>
            <LanguageProvider>
              <App />
            </LanguageProvider>
          </BrowserRouter>
        )}
      </WordPressProvider>
    </StrictMode>
  );
};

export default Root;
